// removed by extract-text-webpack-plugin
module.exports = {"press":"Press__press___36GdX","resume":"Press__resume___2au4B"};


//////////////////
// WEBPACK FOOTER
// ./application/js/pages/Press.css
// module id = 529
// module chunks = 0